import React from "react";
import { Box, Button, MenuItem, Select, Stack, Typography } from "@mui/material";
import DownloadOutlined from "@mui/icons-material/DownloadOutlined";
import ClipResultCard from "./ClipResultCard";

function sortClips(clips, sortBy) {
  const list = [...(clips || [])];
  if (sortBy === "duration") {
    return list.sort((a, b) => (b.duration || 0) - (a.duration || 0));
  }
  if (sortBy === "order") {
    return list;
  }
  return list.sort((a, b) => (b.viral_score || 0) - (a.viral_score || 0));
}

export default function ClipResultGrid({ result, onCopyCaption, onShareClip, lang }) {
  const [sortBy, setSortBy] = React.useState("viral");
  const clips = sortClips(result?.shorts, sortBy);
  const title =
    result?.title ||
    result?.project?.source_title ||
    result?.url ||
    result?.project?.source_url ||
    lang?.clippingSourceVideo ||
    "Source video";

  const downloadAll = () => {
    clips.forEach((clip, i) => {
      if (!clip.video_url) return;
      setTimeout(() => {
        window.open(clip.video_url, "_blank", "noopener,noreferrer");
      }, i * 400);
    });
  };

  return (
    <Stack spacing={2.5}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ sm: "center" }}
        justifyContent="space-between"
        spacing={1.5}
      >
        <Box>
          <Typography variant="h6" fontWeight={800}>
            {(lang?.clippingResultsTitle || "{count} clips generated").replace(
              "{count}",
              String(clips.length),
            )}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            {lang?.clippingResultsFrom || "From"}: {title}
          </Typography>
        </Box>
        <Stack direction="row" spacing={1} alignItems="center">
          <Select size="small" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
            <MenuItem value="viral">{lang?.clippingSortViral || "Viral score"}</MenuItem>
            <MenuItem value="duration">{lang?.clippingSortDuration || "Duration"}</MenuItem>
            <MenuItem value="order">{lang?.clippingSortOrder || "Clip order"}</MenuItem>
          </Select>
          <Button
            variant="outlined"
            size="small"
            startIcon={<DownloadOutlined />}
            onClick={downloadAll}
            disabled={!clips.some((c) => c.video_url)}
            sx={{ borderRadius: 2, fontWeight: 700 }}
          >
            {lang?.clippingDownloadAll || "Download all"}
          </Button>
        </Stack>
      </Stack>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", lg: "1fr 1fr 1fr" },
          gap: 2,
        }}
      >
        {clips.map((clip) => (
          <ClipResultCard
            key={clip.id}
            clip={clip}
            onCopyCaption={onCopyCaption}
            onShare={onShareClip}
            lang={lang}
          />
        ))}
      </Box>
    </Stack>
  );
}
